const state = {
    countryCode: null,
    countryReq: null,
    countryRes: null,


}

// getters
const getters = {
    GET_COUNTRY_CODE: (state) => {
        return state.countryCode;
    },
    GET_COUNTRY_REQ: (state) => {
        return state.countryReq;
    },
    GET_COUNTRY_RES: (state) => {
        return state.countryRes;
    },

}

// actions
const actions = {
    CLEAR_COUNTRY_LIST_STORE({ commit }) {
        commit("clearcountrylsStore");
    },
    SET_COUNTRY_CODE({ commit }, code) {
        commit('getCountryCode', code);
    },
    SET_COUNTRY_REQ({ commit }, req) {
        commit('getCountryReq', req);
    },
    SET_COUNTRY_RES({ commit }, res) {
        commit('getCountryRes', res);
    },

}

// mutations
const mutations = {
    clearcountrylsStore(state) {
        state.countryReq = null;
        state.countryRes = null;
    },
    getCountryCode(state, code) {
        state.countryCode = code
    },
    getCountryReq(state, req) {
        state.countryReq = req
    },
    getCountryRes(state, res) {
        state.countryRes = res
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}